// AdminHome — the agent SPA's home route ("/").
//
// The agent SPA is agent-only (AgentOnly guard in App.tsx), so this simply
// renders the simple agent dashboard. The old role-dispatched mega-dashboard
// (AdminDashboard + the legacy AgentDashboard + their panels, and the
// /reports/agent-home-summary + /me-agent/{leaderboards,activity-feed} fetches)
// was removed 2026-07-04 when the 5-tile dashboard replaced it.

import AgentDashboard from './AgentDashboard';

export default function AdminHome() {
  return <AgentDashboard />;
}
